import { css } from '@emotion/core'
import colors from './colors'

const globals = {
  '*': {
    color: 'inherit',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  },
  'html, body': {
    fontSize: '16px',
    lineHeight: '131.25%',
  },
  body: {
    fontFamily: "'Space Mono', monospace",
    color: colors.white,
    backgroundColor: colors.brown,

    '&.home-view': {
      color: colors.white,
      backgroundColor: colors.lightBrown,
    },

    '&.item-view': {
      '.header-row': {
        color: colors.white,
        backgroundColor: colors.darkBrown,
      },
    },

    '.content-container': {
      backgroundColor: colors.lightBrown,
    },
  },
  img: {
    maxWidth: '100%',
    display: 'block',
  },

  button: {
    backgroundColor: 'transparent',
    borderStyle: 'none',
  },

  a: {
    textDecoration: 'none',
    cursor: 'pointer',
  },

  'h1, h2, h3, h4, h5': {
    fontWeight: 'normal',
  },

  h1: {
    fontSize: '4em',
    paddingBottom: '2rem',
    textTransform: 'uppercase',
    color: colors.grey,
    lineHeight: '120%',
  },

  h2: {
    fontSize: '1rem',
    textTransform: 'uppercase',
    color: colors.grey,
    textDecoration: 'underline',
    marginBottom: '1.25rem',
  },

  '.container-fluid': {
    padding: '0 2rem',
  },

  b: {
    color: 'rgb(201, 198, 215)',
    textDecoration: 'underline',
  },

  video: {
    paddingBottom: '1rem',
    maxWidth: '50%',
  },

  '.body': {
    paddingTop: '3rem',
    textAlign: 'left',
  },

}

export default css(globals)
